const setOrgActiveFeatures = (state, payload) => {
  state.orgActiveFeatures = payload;
};

export default { setOrgActiveFeatures };
